import { withNamespace } from "@/i18n/lazy-route"

/**
 * The account area (LLD §9.2, Task 1.5): five lazy screens, each loading the
 * `account` namespace with its chunk.
 */
const translations = {
  en: () => import("@/i18n/locales/en/account.json"),
  fr: () => import("@/i18n/locales/fr/account.json"),
}

export const ProfileScreen = withNamespace(
  "account",
  () => import("./screens/ProfileScreen"),
  translations,
)
export const SecurityScreen = withNamespace(
  "account",
  () => import("./screens/SecurityScreen"),
  translations,
)
export const SessionsScreen = withNamespace(
  "account",
  () => import("./screens/SessionsScreen"),
  translations,
)
export const NotificationsScreen = withNamespace(
  "account",
  () => import("./screens/NotificationsScreen"),
  translations,
)
export const SupportScreen = withNamespace(
  "account",
  () => import("./screens/SupportScreen"),
  translations,
)
export const DeleteAccountScreen = withNamespace(
  "account",
  () => import("./screens/DeleteAccountScreen"),
  translations,
)
